import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Autocomplete, TextField } from "@mui/material"
import { useTranslation } from "react-i18next"

import { LocationDTO } from "../../../DTOs/Production/LocationDTO"
import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto"
import { useIsReadOnly } from "../../../utilities/helpers/roleUtilities"

type StoppageLocationCellProps = {
  stoppage: StoppageDto,
  locationOptions: LocationDTO[],
  isLocationOptionsLoading: boolean
  handleLocationChange: (stoppage: StoppageDto, locationId: number) => Promise<void>
}

const StoppageLocationCell: React.FC<StoppageLocationCellProps> = ({
  stoppage,
  locationOptions,
  isLocationOptionsLoading,
  handleLocationChange
}) => {
  const { t } = useTranslation("stoppages");
  const isReadOnly = useIsReadOnly();

  return (
    <Autocomplete
      value={locationOptions.find(o => o.id === stoppage.locationId) ?? null}
      classes={{ root: "w-full" }}
      options={locationOptions}
      loading={isLocationOptionsLoading}
      disabled={isLocationOptionsLoading || isReadOnly}
      getOptionLabel={(o) => o.name}
      onChange={(_, opt) => { handleLocationChange(stoppage, opt?.id ?? 0) }}
      renderInput={params => (
        <TextField
          {...params}
          placeholder={t("cells.selectLocation")}
          size="small"
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              endAdornment: (
                <>
                  {isLocationOptionsLoading ?
                    <span className="animate-fade-in"><FontAwesomeIcon icon={faSpinner} spin /></span> : null}
                  {params.slotProps.input.endAdornment}
                </>
              )
            }
          }}
        />
      )}
    />
  )
}

export default StoppageLocationCell